import React from "react";
//#region types
import { FilterWrapperProps } from "models/propTypes/filterPropTypes";
//#endregion
//#region components
import FilterContextProvider from "./context/contextProvider";
import FilterDrawer from "./filterDrawer";
//#endregion

function FilterWrapper<T extends Record<string, any>>(props: React.PropsWithChildren<FilterWrapperProps<T>>) {
  return (
    <FilterContextProvider
      initialFilter={props.initialFilter}
      filterQueryStateHandler={props.filterQueryStateHandler}
      valueFormatter={props.valueFormatter}
      filterCategory={props.filterCategory}
      reportToAPIFilterFormatter={props.reportToAPIFilterFormatter}
      apiToReportFilterFormatter={props.apiToReportFilterFormatter}
      validationSchema={props.validationSchema}
    >
      {props.children}
      <FilterDrawer fields={props.filterFields} validationSchema={props.validationSchema} />
    </FilterContextProvider>
  );
}

export default FilterWrapper;
